module.exports = __webpack_public_path__ + "img/badge-2.8a9c1017.svg";